<template>
    <CreatePart></CreatePart>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const CreatePart = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/PartMaintenance/CreatePart.vue"
    )
);

export default {
    name: "Project_HelpCreatePart", //The name you are in should not equal the name of the component you are importing.
    components: { CreatePart, AuthLayout },
};
</script>
